import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import { FieldContainer, Button } from './styles';

const FieldToCopy = ({ value }) => {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(value)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
      })
      .catch((err) => console.error('Could not copy text: ', err));
  };

  return (
    <FieldContainer>
      <input ref={inputRef} value={value} readOnly />
      <Button onClick={handleCopy}>
        {copied ? <Icon name="check" /> : 'Copy'}
      </Button>
    </FieldContainer>
  );
};

FieldToCopy.propTypes = {
  value: PropTypes.string.isRequired,
};

export default FieldToCopy;
